export const isDirectSignup = (): boolean => {
  const continueParam = new URLSearchParams(window.location.search).get('continue');
  if (!continueParam) return true;
  try {
    const inviteURL = new URL(continueParam);
    const returnUrl = inviteURL.searchParams.get('returnUrl');
    return returnUrl !== '/invite/accept-board' && returnUrl !== '/invite/accept-team';
  } catch (error) {
    console.error('Error parsing continue param', error);
    return true;
  }
};
